import { Button, Dropdown, Modal, Offcanvas } from "react-bootstrap"
import { useFileNavigator } from "../../context/FileNavigator";
import { useEffect, useState } from "react";
import ESpinner from "../others/Spinner";
//import FilesList from "./FilesList";
import FolderBreadcrumbs from "./FolderBreadcrumbs";
import { useTranslation } from "react-i18next";
import DropdownFileNavigator from "./DropdownFileNavigator";
import UploadFileProgress from "./UploadFileProgress";
import SolarFolderWithFilesBold from "../icons/SolarFolderWithFilesBold";
import i18n from 'i18next';
import Loadable from "../Loadable";
import { imgTypes, textTypes } from "../../utils/helpers/structs/fileTypes";
const ImageEditor = Loadable(()=>import('../ImageEditor'),false);
const TextFileEditor = Loadable(()=>import('../TextFileEditor'),false);
const FilesList = Loadable(()=>import('./FilesList'),false);


const FileNavigator = () => {
    
    const { stateFN, dispatchFN, fetchDataFN } = useFileNavigator();
    const [ filesList, setFilesList ] = useState(null);
    const { t } = useTranslation(['FileNavigator']);
    const [ progress, setProgress ] = useState(0);
    const [ fileData4Edit, setFileData4Edit ] = useState(null);

    const handleHide = () =>{
        dispatchFN({type:'SET_SHOW_FN', payload: false});
        setTimeout(() => {
            dispatchFN({type:'SET_DATA_FN', payload: null}) ;
        }, 150);
    } 

    const cbSavedImage = (stat) => {
        fetchDataFN(true, false);
    }

    useEffect(()=>{
        // Якщо немає 
        if (!stateFN.dataFN) return setFilesList(null);
        const _filesList = stateFN.dataFN?.dirList?.filter(file => file.filePath === stateFN.currentPathFN);
        setFilesList(_filesList );

    },[stateFN.dataFN, stateFN.currentPathFN])

    useEffect(()=>{
        // Ресетимо додаткові параметри при закритті з затримкою
        // 500 мілісекунд для того щоб дати час візуально закрити канвас
        if (!stateFN.showFN) 
            setTimeout(() => {
                dispatchFN({type:'RESET_ADD_PARAM'});    
            }, 500); 
    }, [stateFN.showFN]);

 
    return  (
        <>
            <Offcanvas
                show={stateFN.showFN}  
                placement="end"
                keyboard={false}
                onHide={()=>handleHide()}
                onShow={()=> (!stateFN?.dataFN) ? fetchDataFN() : null}>
                <Offcanvas.Header 
                    closeButton
                    className="border-bottom">
                    <div className="d-flex justify-content-between w-100">
                        <Offcanvas.Title>{t('titleCanvas')}</Offcanvas.Title>
                        <DropdownFileNavigator
                            setProgress={setProgress}/>
                    </div>
                </Offcanvas.Header>
                <UploadFileProgress progress={progress}/>
                <Offcanvas.Body>
                    <FolderBreadcrumbs/>
                    {filesList
                        ? <FilesList filesList={filesList}
                            setFileData4Edit={setFileData4Edit}/>
                        : <ESpinner/> 
                    }                 
                </Offcanvas.Body>
                <div style={{minHeight:'15px'}}></div>
            
             
            </Offcanvas>
              
            {imgTypes.includes(fileData4Edit?.fileType?.toLowerCase()) !== false && ( 
                <ImageEditor 
                    cb={cbSavedImage}
                    fileData={fileData4Edit} 
                    setFileData4Edit={setFileData4Edit}/> 
            )}

            {textTypes.includes(fileData4Edit?.fileType?.toLowerCase()) !== false && ( 
                <TextFileEditor 
                    cb={cbSavedImage}
                    fileData={fileData4Edit} 
                    setFileData4Edit={setFileData4Edit}/> 
            )}
        </>
         
    )
}

export default FileNavigator;